import * as React from 'react'

import type { DiscussionVisibility } from 'types/discussion'
import type { TrackId } from 'types/track'

import { Box, DiscoCallout } from 'components/ds'

import CommentEditor from './comment-editor'
import DiscussionVisibilityControl from './visibility-control'

type Props = {
  trackIds: TrackId[]
  visibility: DiscussionVisibility
  onVisibilityChange: (visibility: DiscussionVisibility) => void
}

const BulkTrackDiscussions = ({
  trackIds,
  visibility,
  onVisibilityChange,
}: Props): React.ReactElement => {
  return (
    <Box width="100%">
      <DiscussionVisibilityControl
        value={visibility}
        onValueChange={onVisibilityChange}
      />
      <Box my="4">
        <DiscoCallout type="info">
          {`You are editing ${trackIds.length} tracks. Newly created notes will be added to all selected tracks.`}
        </DiscoCallout>
      </Box>
      <Box pt="3">
        <CommentEditor
          key={visibility}
          mode="bulk-create"
          trackIds={trackIds}
          visibility={visibility}
        />
      </Box>
    </Box>
  )
}

export default BulkTrackDiscussions
